/*
 * Event handlers for Network tab formsets on Group and Env detail pages.
 * Ported from c2Archive/networkTableAndFormset.js.
 * Used by templates/resourcehandlers/slayer/env-tab-networks_table.html.
 */

(function (__module__, c2, $) {
  'use strict';

  var tableURL;
  var $box;
  var depletedMsg = gettext('There are no more networks to add.');


  function init(theTableURL, vpcID) {
    tableURL = theTableURL;

    $(function () {
      $box = $('#networkListBox');

      // init.js runs c2.dataTables.init() before this handler, so destroy it
      // first to capture clean (pre-DataTables) HTML as our restore point.
      if ($.fn.DataTable.isDataTable('#networks')) {
        $('#networks').DataTable().destroy();
      }
      $('body').data('origNetworksTable', $box.html());

      $box.off('click');
      $box.on('click', 'button.cancel', cancelMakeChanges);
      $box.on('click', '.convertToForm', fetchFormset);
      $box.on('click', '.remove-all-networks', function(e) {
        e.preventDefault();
        $('#networks tbody .delete-form').trigger('click');
      });

      if (vpcID) {
        depletedMsg = '';
      }

      $box.off('submit');
      $box.on('submit', submitFormset);

      c2.dataTables.init('#networks');
    });
  }


  function cancelMakeChanges(clickEvent) {
    clickEvent.preventDefault();
    $box.html($('body').data('origNetworksTable'));
    c2.spinners.hideSpinner({selector: '#networkListBox', fade: true});
    c2.dataTables.init('#networks');
  }


  // Clicking an existing checkbox in this way allows new network rows to be
  // added and selected. Bandaid for DEV-9295.
  function hackToPreventDisappearingRows() {
    $('.networks-dynamic-form').find('input:checkbox:not(:checked):first').click().click();
  }


  function fetchFormset(clickEvent) {
    c2.spinners.showSpinner({selector: '#networkListBox', fade: true});

    $.get(tableURL, function (response) {
      $box.html(response);

      $('#editNetworksForm tbody tr').formset({
        addLabel: '<span class="bi bi-plus-lg"></span> ' + gettext('Add a network'),
        showDeleteAllLink: false,
        added: networkFormsetAdded,
        formTemplate: $('#network_form_template'),
        hideRemovedRows: false,
        prefix: 'networks',
        formCssClass: 'networks-dynamic-form',
        deleteClass: 'btn btn-default btn-sm delete-form',
        deleteLabel: '<span class="bi bi-x-lg"></span>',
      });

      hideAddLinkWhenDepleted($('body').data('possibleNetworks'), depletedMsg);
      c2.dataTables.init('#networks');
      hackToPreventDisappearingRows();
      c2.spinners.hideSpinner({selector: '#networkListBox', fade: true});
    });
  }


  function submitFormset(event) {
    event.preventDefault();

    var data = $('#editNetworksForm input, #editNetworksForm select').serialize();
    data += '&' + $('#networks').DataTable().rows().nodes().to$().find('input').serialize();

    $.post(tableURL, data, function (data) {
      if (data['errors']) {
        console.log(data);
      } else {
        $box.html(data);
        c2.alerts.addGlobalAlert(gettext('Network options have been saved.'), 'success', true, 10000);
      }
    });

    return false;
  }


  function networkFormsetAdded($row) {
    var td = $row.addClass('new-dynamic-form').find('td.network');
    var net_field = td.find('input');
    var $select = $('<select></select>')
      .prop('id', net_field.prop('id'))
      .prop('name', net_field.prop('name'));

    var possible = $('body').data('possibleNetworks');
    for (var i = 0; i < possible.length; i++) {
      $select.append('<option value="' + possible[i][0] + '">' + possible[i][1] + '</option>');
    }
    net_field.remove();
    td.prepend($select);
    c2.selectize('#' + $select.prop('id'));

    hideAddLinkWhenDepleted(possible, gettext('There are no more networks to add.'));

    var links = $row.last().find('.delete-form');
    if (links.length > 1) {
      links.last().remove();
    }

    $row.find('td.nic1 input').prop('checked', true);
  }


  function hideAddLinkWhenDepleted(list, msg) {
    if (list.length === 0) {
      $('a.add-form').replaceWith('<p>' + msg + '</p><br>');
    }
  }


  c2[__module__] = {
    init: init,
  };

})('networkTableAndFormset', window.c2, window.jQuery);
